// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-table th {\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\nth.header-item-title {\n  font-size: 14px;\n}\ntr.order-total th {\n  font-size: 18px;\n  font-weight: 400;\n}\ntr.order-total td {\n  font-size: 22px;\n  font-weight: 600 !important;\n}", ""]);
// Exports
module.exports = exports;
